import React, { useState } from "react";
import TrackBox from "./tracking/list/trackBox";
import DonwloadMISfromAWB from "../pages/AWBbasedMIS";
import PageTitle from "./PageTitle";
import PillFilters from "../pages/AppointmentDeliveriesV2/shared/PillFilters";

const PILLS = [
    { key: 0, label: "Bulk Tracking" },
    { key: 1, label: "Download MIS from AWB" },
];

function BulkTracking() {
    const [active, setActive] = useState(0);

    return (
        <>
            <PageTitle>Bulk Tracking</PageTitle>
            <PillFilters pills={PILLS} value={active} onChange={setActive} />
            {active === 0 && <TrackBox />}
            {active === 1 && <DonwloadMISfromAWB />}
        </>
    );
}

export default BulkTracking;
